// extracted by mini-css-extract-plugin
module.exports = {"layout":"_9e1425b4d3--layout--SHgMu","spinner":"_9e1425b4d3--spinner--CczFU","container":"_9e1425b4d3--container--qDhh7","error":"_9e1425b4d3--error--_bpHQ"};